import React, {PureComponent} from 'react'
import { findIndex, map, debounce, isEqual } from "lodash-es"
import { Link, Redirect } from 'react-router-dom'
import AnswerOptions from './answer-options'
import NavBar from "./navigation/nav-bar"
import CatalystProgressBar from './catalyst-progress-bar'
import {
  getThemeStyle, getAvailableThemes, getAvailableQuestions
} from "../utilities/helpers"
import { formPagePath } from '../utilities/route'
import Button from './ui/button'

const getNextAvailableTheme = (currentThemeId, availableThemes) => {
  const currentIndex = findIndex(availableThemes, (t) => t.id === currentThemeId)
  if (currentIndex < availableThemes.length - 1) {
    return availableThemes[currentIndex + 1]
  } else {
    return undefined
  }
}

class QuestionsPage extends PureComponent {

  constructor(props) {
    super(props)
    this.public = [];
  }

  componentDidMount() {
    const { onSubmitError } = this.props
    onSubmitError(false)
  }

  componentDidUpdate(prevProps) {
    if (!isEqual(prevProps.location, this.props.location)) {
      window.scrollTo(0, 0);
    }
  }

  answerQuestion = (value, question) => {
    //console.log("answerQuestion", value, question)
    const {
      match: {
        params: { languageCode },
      },
      answerQuestion,
      onSubmitError,
    } = this.props;

    const variables = {
      languageCode,
      answer: {
        questionId: question.id,
        response: value,
      },
    };

    return answerQuestion({ variables })
      .catch((err) => onSubmitError(err));
  }

  answerOpenQuestion = (value, questionId) => {
    const {
      match: {
        params: { languageCode },
      },
      answerOpenQuestion,
      onSubmitError
    } = this.props;

    const checkBoxIndex = this.public.findIndex((el) => el && el.id && el.id.includes(questionId))

    const variables = {
      languageCode,
      answer: {
        questionId,
        response: value,
        // public: checkBoxIndex !== -1 ? this.public[checkBoxIndex].checked : false
        public: true // for now we are harcoding it to true
      },
    };

    return answerOpenQuestion({ variables })
      .catch((err) => onSubmitError(err));
  }

  rateQuestion = (value, question) => {
    //console.log("rateQuestion", value, question)
    const {
      match: {
        params: { languageCode },
      },
      rateQuestion,
      onSubmitError,
    } = this.props;

    const variables = {
      languageCode,
      rate: {
        questionId: question.id,
        rate: value,
      },
    }

    return rateQuestion({ variables })
      .catch((err) => onSubmitError(err));
  }

  renderQuestion = (question, i) => {
    const surveyThemeIndex = this.getSurveyThemeIndex();
    const themeStyle = getThemeStyle(surveyThemeIndex)
    return (
      <AnswerOptions
        key={question.id}
        question={question}
        rateQuestion={this.rateQuestion}
        answerQuestion={this.answerQuestion}
        color={themeStyle.bgColor}
        t={this.t}
        number={i < 9 ? `0${i + 1}` : i + 1}
      />
    );
  };

  renderIntro = () => {
    const currentTheme = this.getCurrentTheme();
    const availableThemes = getAvailableThemes(this.props.questionnaire.parameters, this.getSurveyThemes())
    const availableThemeIndex = findIndex(availableThemes, (t) => t.id === currentTheme.id)
    const surveyThemeIndex = this.getSurveyThemeIndex();
    const themeStyle = getThemeStyle(surveyThemeIndex)
    return (
      <div className={`catalyst-intro theme-${surveyThemeIndex}`}
        style={{
          backgroundColor: themeStyle.bgColor,
        }}
      >
        <div className="catalyst-bg-img">
          <img src={themeStyle.bgImage} alt="Shapes"/>
        </div>
        <div className="questions d-flex flex-column align-items-center">
          <div
            className="question-container bg-transparent mb-0"
            style={{ boxShadow: "none" }}
          >
            <div className="theme-number serif-text-lg">
              {this.t("hero_subtitle")} {availableThemeIndex + 1}
            </div>
            <h2>{currentTheme.title}</h2>
            <div className="catalyst-description mb-0">
              {currentTheme.description}
            </div>
          </div>
        </div>
      </div>
    );
  };

  onOpenQuestionChange = (e, id) => {
    /* signal to React not to nullify the event object */
    if (e.persist) e.persist();
    if (!this.debouncedFn) {
      this.debouncedFn =  debounce((e, id) => {
        this.answerOpenQuestion(e.target.value, id);
      }, 300);
    }

    this.debouncedFn(e, id);
  }

  renderGroup = () => {
    const currentTheme = this.getCurrentTheme()
    const likertQuestions = getAvailableQuestions('likert', this.props.questionnaire.parameters, currentTheme)
    const openQuestions = getAvailableQuestions('open', this.props.questionnaire.parameters, currentTheme)
    return (
      <fieldset>
        {this.renderIntro()}
        <div className="questions-container">
          <div className="questions d-flex flex-column align-items-center">
            {map(likertQuestions, this.renderQuestion)}
          </div>
          {openQuestions && map(openQuestions, (openQuestion, index) => (
            <div key={openQuestion.id} className="questions d-flex flex-column align-items-center">
              <div className="question-container">
                <div className="question-container__inner">
                  <label className="question-title">
                    {openQuestion.title}
                  </label>
                  <textarea
                    className="d-flex w-100 open-question"
                    placeholder={this.t("open_question_placeholder")}
                    defaultValue={openQuestion.response}
                    onChange={e => this.onOpenQuestionChange(e, openQuestion.id)}
                  />
                  <div className="d-none align-items-center justify-content-between mt-3 make-public">
                    <div className="d-flex align-items-center">
                      <input
                        ref={(ref) => (this.public[index] = ref)}
                        defaultChecked={openQuestion.public ? true : true}
                        onChange={() =>
                          this.onOpenQuestionChange({
                            target: {
                              value: openQuestion.response,
                            },
                          }, openQuestion.id)
                        }
                        type="checkbox"
                        name="make-public"
                        className="mr-2"
                        id={`input-${openQuestion.id}`}
                      />
                      <label htmlFor={`input-${openQuestion.id}`}>{this.t("make_public")}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </fieldset>
    );
  };

  getSurveyThemes = () => {
    const {
      questionnaire: { catalysts: surveyThemes },
    } = this.props;
    return surveyThemes
  };

  getCurrentThemeId = () => {
    const {
      match: {
        params: { catalystId: currentThemeId },
      },
    } = this.props;
    return currentThemeId
  };

  getCurrentTheme = () => {
    const currentThemeId = this.getCurrentThemeId()
    return this.getSurveyThemes().find((t) => t.id === currentThemeId)
  };

  getSurveyThemeIndex = () => {
    const currentThemeId = this.getCurrentThemeId()
    return findIndex(this.getSurveyThemes(), t => t.id === currentThemeId)
  }

  allQuestionsAnswered = () => {
    const availableLikertQuestions = getAvailableQuestions('likert', this.props.questionnaire.parameters, this.getCurrentTheme())
    let allAnswered = true
    availableLikertQuestions.forEach(question => {
      if ((!question.answered || !question.rate) && !question.skipped) {
        allAnswered = false
      }
    })
    return allAnswered
  }

  renderError() {
    const { submitError } = this.props;

    if (submitError) {
      if (process.env.NODE_ENV === "development") {
        return (
          <div className="btn-alert flex alert alert-danger questionnaire-error mt-0">
            {submitError.message}
          </div>
        );
      }

      return (
        <div className="btn-alert flex alert alert-danger questionnaire-error mt-0">
          Error submitting answers. Please try again later.
        </div>
      );
    }
  }

  t = (phrase) => {
    const { useTranslate } = this.props

    return useTranslate(`questions.${phrase}`)
  }

  render() {
    const {
      questionnaire: {
        catalysts: surveyThemes,
        hideCatalystThemePages,
        canAnswer,
        isAfterGameGuest
      },
      match: {
        params: { surveyId, languageCode },
      },
      useTranslate,
    } = this.props;

    const availableThemes = getAvailableThemes(this.props.questionnaire.parameters, surveyThemes)
    const currentThemeId = this.getCurrentThemeId()
    const nextAvailableTheme = getNextAvailableTheme(currentThemeId, availableThemes)
    const isLastAvailableTheme = (nextAvailableTheme === undefined)
    const to = !isLastAvailableTheme
      ? formPagePath(languageCode, surveyId, 'catalyst', nextAvailableTheme.id, ...(hideCatalystThemePages ? ['questions'] : []))
      : formPagePath(languageCode, surveyId, 'finish');

    const jumpToThemePage = (themeId) => {
      this.props.history.push(formPagePath(languageCode, surveyId, 'catalyst', themeId));
    }

    // We redirect if aftergame is on
    if (!canAnswer || isAfterGameGuest) {
      return <Redirect to={formPagePath(languageCode, surveyId, 'finish')} />;
    }

    return (
      <section className="questions questions-page">
        <div className="questions-page__container white-bg">
          <NavBar middleChildren>
            <CatalystProgressBar
              currentThemeId={currentThemeId}
              availableThemes={availableThemes}
              handleClick={jumpToThemePage}
              t={(phrase) => useTranslate(`theme.${phrase}`)}
            />
          </NavBar>
        </div>
        <div
          className="col questions-page__container"
        >
          <form className="position-relative">
            {this.renderGroup()}
            <div className="questions d-flex flex-column align-items-center">
              <div
                className="question-container bg-transparent"
                style={{
                  position: "relative",
                  bottom: "100px",
                }}
              >
                {this.renderError()}
                <Button
                  as={Link}
                  to={to}
                  className={`w-100 ${!this.allQuestionsAnswered() && "disabled"}`}
                  onClick={() => {isLastAvailableTheme && sessionStorage.setItem("surveyBeingEdited", "false");}}
                >
                  {!isLastAvailableTheme ? this.t("submit_answers") : this.t("submit_survey")}
                </Button>
                {!this.allQuestionsAnswered() &&
                  <div className={"answers-missing"}>
                    <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9.5415 5.70817H11.4582V7.62484H9.5415V5.70817ZM9.5415 9.5415H11.4582V15.2915H9.5415V9.5415ZM10.4998 0.916504C5.20984 0.916504 0.916504 5.20984 0.916504 10.4998C0.916504 15.7898 5.20984 20.0832 10.4998 20.0832C15.7898 20.0832 20.0832 15.7898 20.0832 10.4998C20.0832 5.20984 15.7898 0.916504 10.4998 0.916504ZM10.4998 18.1665C6.27359 18.1665 2.83317 14.7261 2.83317 10.4998C2.83317 6.27359 6.27359 2.83317 10.4998 2.83317C14.7261 2.83317 18.1665 6.27359 18.1665 10.4998C18.1665 14.7261 14.7261 18.1665 10.4998 18.1665Z" fill="#E87716"/>
                    </svg>
                    <span>{this.t("submit_info")}</span>
                  </div>
                }
              </div>
            </div>
          </form>
        </div>
      </section>
    );
  }
}

export default QuestionsPage



// WEBPACK FOOTER //
// ./src/components/questions-page.js